import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Search = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 24 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.3694 9.73469C15.3694 12.8466 12.8466 15.3694 9.73469 15.3694C6.62274 15.3694 4.1 12.8466 4.1 9.73469C4.1 6.62274 6.62274 4.1 9.73469 4.1C12.8466 4.1 15.3694 6.62274 15.3694 9.73469ZM14.0921 14.8699C12.9176 15.8675 11.3964 16.4694 9.73469 16.4694C6.01523 16.4694 3 13.4542 3 9.73469C3 6.01523 6.01523 3 9.73469 3C13.4542 3 16.4694 6.01523 16.4694 9.73469C16.4694 11.3964 15.8675 12.9176 14.8699 14.0921L20.495 19.7172C20.7098 19.932 20.7098 20.2802 20.495 20.495C20.2802 20.7098 19.932 20.7098 19.7172 20.495L14.0921 14.8699Z"
        fill={color}
      />
    </svg>
  )
})

export default Search
